import classNames from 'classnames';

import styles from './LeftMenuLayout.module.scss';

export interface LeftMenuItem {
  title: string;
  icon: string;
  iconActive?: string;
  onClick: () => void;
  active?: boolean;
  hide?: boolean;
}

interface LeftMenuLayoutProps {
  children: React.ReactNode;
  leftMenuItems?: LeftMenuItem[];
}

const LeftMenuLayout: React.FC<LeftMenuLayoutProps> = ({ children, leftMenuItems }) => {
  return (
    <div className={styles.Container}>
      <div className={styles.leftMenu}>
        {leftMenuItems?.map(({ title, icon, iconActive, onClick, active, hide }, index) => {
          if (hide) return null;
          return (
            <div
              key={title + index}
              className={classNames(styles.leftMenu_item, {
                [styles.leftMenu_item_active]: active
              })}
              onClick={onClick}
            >
              <div className={styles.leftMenu_item_icon}>
                <img src={active && iconActive ? iconActive : icon} alt="" />
              </div>
              <div className={styles.leftMenu_item_title}>{title}</div>
            </div>
          );
        })}
      </div>
      <div className={styles.mainFromContainer}>{children}</div>
    </div>
  );
};

export default LeftMenuLayout;
